@if (mdContent) {
  <article #markdownContainer class="max-w-none p-6 bg-lGray900">
    <markdown class="markdown-body" emoji katex lineNumbers lineHighlight commandLine [data]="mdContent" (ready)="onMarkdownReady()" />
  </article>
} @else {
  <div class="grid h-full min-h-[330px] place-items-center px-6 text-center text-lWhite/75 bg-lGray900">
    <p>Conteúdo textual indisponível para esta aula.</p>
  </div>
}
